// This file is automatically updated from package.json by grunt.
module.exports = {
  full: '0.6.4',
  major: 0,
  minor: 6,
  dot: 4
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/leapjs/lib/version.js
 ** module id = 44
 ** module chunks = 0
 **/